const _excluded = ["videoSrc", "videoType", "loop", "buttonTopAlignment", "buttonBottomLeftAlignment", "buttonTopLeftAlignment", "buttonTopRightAlignment", "click", "hoverVideoPlay", "carouselEvent", "structuredScript", "structuredScriptData", "buttonCenterAlignment", "autoplay", "muted", "buttonFilled", "videoFullHeight", "isDetSite", "isSharedCh", "isHero"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './Video.css';
import React, { useState, useCallback, useMemo } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { canUseDOM, getGlobalDictionaryTerm } from '../../../utils';
import IconPauseItem from '../../../components/atoms/Icons/IconPause2';
import IconPlayItem from '../../../components/atoms/Icons/IconPlay';
import IconPlay2Item from '../../../components/atoms/Icons/IconPlay2';
import IconPlayDDA from '../../../components/atoms/Icons/IconDDAPlay';
import IconPauseDDA from '../../../components/atoms/Icons/IconDDAPause';
import { useVideoStructuredData } from './useVideoStructuredData';
import { useInView } from 'react-intersection-observer';
import clsx from 'clsx';
import throttle from 'lodash/throttle';
const videoWhiteOverlayTime = 750;
const videoFadeTime = 400;
const Video = _ref => {
  let {
      videoSrc,
      videoType = '',
      loop = true,
      buttonTopAlignment = false,
      buttonBottomLeftAlignment = false,
      buttonTopLeftAlignment = false,
      buttonTopRightAlignment = false,
      click,
      hoverVideoPlay,
      carouselEvent,
      structuredScript = false,
      structuredScriptData = '',
      buttonCenterAlignment = false,
      autoplay = false,
      muted = false,
      buttonFilled = true,
      videoFullHeight = false,
      isDetSite = false,
      isSharedCh = false,
      isHero = false
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const [isInAnimatingHeader, setIsInAnimatingHeader] = React.useState(false);
  const [playVideo, setPlayVideo] = React.useState(false);
  const [paused, setPaused] = React.useState(true);
  const [isButtonCenterOpacity, setIsButtonCenterOpacity] = useState(false);
  const [isAnimating, setIsAnimating] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const internalVideo = React.useRef();
  const topDiv = React.useRef();
  const iframePlayerRef = React.useRef();
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const playButtonLabel = getGlobalDictionaryTerm(sitecoreContext, 'atomVideoPlayBtn') || 'Play video';
  let breakpointValue = 992;
  const [breakpoint, setBreakpoint] = React.useState(breakpointValue);
  let isAnimationHeader = false;
  useVideoStructuredData(structuredScriptData);
  const isShown = playVideo || isInAnimatingHeader || hoverVideoPlay || autoplay;
  const youTubeVideoID = useMemo(() => {
    if (videoSrc) {
      const matchArr = videoSrc.match(/(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\/?\?v=|\/embed\/|\/)([^\s&?/#]+)/);
      return matchArr ? matchArr[1] : '';
    }
    return '';
  }, [videoSrc]);
  const [ytPlayerId] = React.useState(`${Math.random().toString(16).slice(2)}-youtube-player-${youTubeVideoID}`);
  // const [player, setPlayer] = React.useState<any>(null);
  const player = React.useRef(null);
  const [ref, inView] = useInView({
    triggerOnce: false
  });
  const updateVideoLocalStorage = status => {
    const videosStorage = sessionStorage.getItem('videoStorage');
    if (videosStorage) {
      let prevStorage = JSON.parse(videosStorage);
      prevStorage.forEach(el => {
        if (el.id === `storage-${videoSrc}`) {
          el.isPlaying = status;
        } else {
          el.isPlaying = !status;
        }
      });
      sessionStorage.setItem('videoStorage', JSON.stringify(prevStorage));
      window.dispatchEvent(new Event('storage'));
    }
  };
  const checkVideoToLocalStorage = () => {
    const videoItemId = `storage-${videoSrc}`;
    let videosStorage = sessionStorage.getItem('videoStorage');
    let videoItemArray = [];
    if (videosStorage) {
      videoItemArray = JSON.parse(videosStorage);
      // video pause
      videoItemArray.forEach(el => {
        if (el.id === videoItemId && !el.isPlaying) {
          if (videoType === 'external') {
            if (player.current && player.current.pauseVideo) {
              player.current.pauseVideo();
            }
          } else {
            if (internalVideo && internalVideo.current) {
              internalVideo.current.pause();
            }
            setPaused(true);
          }
        }
      });
    }
  };
  React.useEffect(() => {
    //set the list video to storage with false status
    const videoItem = {
      id: `storage-${videoSrc}`,
      isPlaying: false
    };
    let videosStorage = sessionStorage.getItem('videoStorage');
    let videoItemArray = [];
    if (videosStorage) {
      let prevStorage = JSON.parse(videosStorage);
      let index = prevStorage.findIndex(item => item.id === `storage-${videoSrc}`);
      if (index === -1) {
        prevStorage.push(videoItem);
        videoItemArray = [...prevStorage];
        sessionStorage.setItem('videoStorage', JSON.stringify(videoItemArray));
      }
    } else {
      videoItemArray.push(videoItem);
      sessionStorage.setItem('videoStorage', JSON.stringify(videoItemArray));
    }
  }, []);
  React.useEffect(() => {
    if (isShown && !inView) {
      if (videoType === 'external') {
        if (player.current && player.current.pauseVideo) {
          player.current.pauseVideo();
        }
      } else {
        if (internalVideo && internalVideo.current) {
          internalVideo.current.pause();
        }
        setPaused(true);
      }
    }
  }, [inView, isShown, videoType]);
  React.useEffect(() => {
    if (isShown && videoType === 'external') {
      if (player.current !== null) {
        if (player && player.current.playVideo) {
          player.current.playVideo();
          updateVideoLocalStorage(true);
        }
      }
    }
  }, [isShown, videoType]);
  const onPlayerStateChange = event => {
    // 1  = playing state
    if (event.data === 1) {
      updateVideoLocalStorage(true);
    }
  };
  React.useEffect(() => {
    if (canUseDOM) {
      if (topDiv.current.closest('.header-animation-breakpoint')) {
        breakpointValue = parseInt(topDiv.current.closest('.header-animation-breakpoint').getAttribute('data-animation-breakpoint')) || breakpointValue;
        setBreakpoint(breakpointValue);
      }
      if (window.screen.width >= breakpointValue && (videoType === 'internal' || videoType === 'media')) {
        setIsInAnimatingHeader(topDiv.current.closest('.header-animation') ? true : false);
      }
    }
  }, []);
  React.useEffect(() => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined' && videoType === 'external' && youTubeVideoID) {
      const playerNodeId = iframePlayerRef.current ? iframePlayerRef.current.id : '';
      const loadVideo = () => {
        if (!player.current && window.YT.Player) {
          if (playerNodeId) {
            player.current = new window.YT.Player(playerNodeId, {
              videoId: youTubeVideoID,
              events: {
                onStateChange: onPlayerStateChange
              }
            });
          }
        }
      };
      if (window.YT && window.YT.loaded) {
        loadVideo();
      } else {
        window.onYouTubeIframeAPIReady = loadVideo;
      }
    }
  }, [youTubeVideoID, videoType]);
  React.useEffect(() => {
    window.addEventListener('storage', checkVideoToLocalStorage);
    return () => {
      window.removeEventListener('storage', checkVideoToLocalStorage);
    };
  }, []);
  React.useEffect(() => {
    if (canUseDOM) {
      if (internalVideo && internalVideo.current) {
        internalVideo.current.pause();
        setPaused(true);
      }
    }
  }, [carouselEvent]);
  const hoverEffect = play => {
    if (canUseDOM) {
      if (hoverVideoPlay) {
        if (internalVideo.current) {
          if (play) {
            internalVideo.current.play();
            updateVideoLocalStorage(true);
          } else {
            internalVideo.current.pause();
          }
        }
      }
    }
  };
  React.useEffect(() => {
    if (canUseDOM) {
      if (autoplay) {
        if (internalVideo.current) {
          internalVideo.current.play();
          document.querySelectorAll('.video-control-btn-hidden').forEach(btn => {
            btn.style.display = 'none';
          });
        }
      }
    }
  });
  React.useEffect(() => {
    if (canUseDOM) {
      if (isSharedCh) {
        if (internalVideo.current) {
          if (autoplay && loading) {
            internalVideo.current.play();
            document.querySelectorAll('.video-control-btn-hidden').forEach(btn => {
              btn.style.display = 'none';
            });
          } else {
            internalVideo.current.pause();
          }
        }
      }
    }
  }, [autoplay]);
  const handlePlayClick = useCallback(() => {
    isAnimationHeader = false;
    if (canUseDOM) {
      if (window.screen.width >= breakpoint) {
        isAnimationHeader = topDiv.current.closest('.header-animation') ? true : false;
      }
    }
    if (isAnimationHeader) {
      if (videoType !== 'external' && internalVideo && internalVideo.current) {
        if (!isAnimating) {
          setIsAnimating(true);
          if (!paused) {
            setPaused(!paused);
            internalVideo.current.pause();
            topDiv.current.closest('.header-animation').classList.remove('header-video--appear');
            setTimeout(() => {
              topDiv.current.closest('.header-animation--play').classList.remove('header-animation--play');
            }, videoFadeTime);
            setTimeout(() => {
              setIsAnimating(false);
            }, videoFadeTime + videoWhiteOverlayTime);
          } else {
            topDiv.current.closest('.header-animation').classList.add('header-animation--play');
            setTimeout(() => {
              if (paused) {
                topDiv.current.closest('.header-animation').classList.add('header-video--appear');
                internalVideo.current.play();
                updateVideoLocalStorage(true);
                setPaused(!paused);
                setIsAnimating(false);
              }
            }, videoWhiteOverlayTime);
          }
        }
      } else {
        if (!isAnimating) {
          setIsAnimating(true);
          if (!paused) {
            topDiv.current.closest('.header-animation').classList.remove('header-video--appear');
            setTimeout(() => {
              topDiv.current.closest('.header-animation--play').classList.remove('header-animation--play');
            }, videoFadeTime);
            setTimeout(() => {
              setIsAnimating(false);
            }, videoFadeTime + videoWhiteOverlayTime);
          } else {
            topDiv.current.closest('.header-animation').classList.add('header-animation--play');
            setTimeout(() => {
              if (paused) {
                topDiv.current.closest('.header-animation').classList.add('header-video--appear');
              }
            }, videoWhiteOverlayTime);
          }
        }
        videoPlayPause();
      }
    } else {
      videoPlayPause();
    }
  }, [breakpoint, paused, setPlayVideo, setPaused, internalVideo, isAnimating]);
  const videoPlayPause = () => {
    if (internalVideo && internalVideo.current) {
      if (paused) {
        internalVideo.current.play();
        updateVideoLocalStorage(true);
        // if(click) { click.bind('play') }
      } else {
        internalVideo.current.pause();
        // if(click) { click('pause') }
      }
    }
    setPaused(!paused);
    setPlayVideo(true);
  };
  const checkMouseMoved = throttle(() => {
    if (isButtonCenterOpacity && buttonCenterAlignment) {
      setIsButtonCenterOpacity(false);
    }
  }, 500);
  React.useEffect(() => {
    if (buttonCenterAlignment) {
      let timer;
      if (!isButtonCenterOpacity && !paused) {
        timer = setTimeout(() => {
          setIsButtonCenterOpacity(true);
        }, 1000);
      }
      return () => {
        clearTimeout(timer);
      };
    }
  }, [isButtonCenterOpacity, paused]);
  const renderVideo = () => {
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      style: {
        height: '100%'
      }
    }, videoType === 'external' ? /*#__PURE__*/React.createElement("div", {
      ref: iframePlayerRef,
      id: ytPlayerId,
      className: "youtube-video-iframe video-item"
    }) : /*#__PURE__*/React.createElement("video", _extends({
      className: clsx('video-atom', 'video-item', {
        'video-paused': paused
      }, {
        [StyledVideoFitCover]: videoFullHeight
      }, {
        [StyledVideo]: !videoFullHeight
      }, muted ? 'rs_skip' : ''),
      ref: internalVideo,
      playsInline: true,
      autoPlay: hoverVideoPlay ? false : !isInAnimatingHeader,
      controls: true,
      loop: loop,
      onProgress: () => setLoading(true),
      onMouseEnter: () => hoverEffect(true),
      onMouseLeave: () => hoverEffect(false),
      onClick: () => {
        setIsButtonCenterOpacity(paused);
        setPaused(!paused);
      },
      style: muted ? {
        pointerEvents: 'none',
        userSelect: 'none'
      } : {}
    }, muted && {
      'aria-hidden': true,
      tabIndex: -1
    }, {
      preload: `${!isInAnimatingHeader || isSharedCh ? 'auto' : 'none'}`,
      muted: muted
    }, otherProps), /*#__PURE__*/React.createElement("source", {
      src: videoSrc,
      type: "video/mp4"
    }), /*#__PURE__*/React.createElement("track", {
      kind: "captions"
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: topDiv,
    "data-testid": "you-tube-video",
    className: clsx(container, 'youtube-video-container', {
      'youtube-video-container--hover': hoverVideoPlay
    }, loading && isSharedCh ? {} : {
      'video-hidden': !isShown
    }, {
      'hidden-play-button': buttonCenterAlignment && isButtonCenterOpacity
    }),
    onMouseMove: checkMouseMoved
  }, renderVideo(), videoType === 'external' && !paused ? null : /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      if (click) {
        click(paused ? 'Play' : 'Paused');
      }
      handlePlayClick();
    },
    className: clsx('rs_skip', 'video-control-btn', {
      'video-control-btn--shared': isSharedCh
    }, 'my-icon-white', {
      'video-control-btn-hidden': autoplay
    }, {
      [rtlButton]: rtl
    }, {
      [ltrButton]: !rtl
    }, {
      [topButton]: buttonTopAlignment
    }, {
      [bottomButton]: !buttonTopAlignment
    }, {
      [leftBottomButton]: buttonBottomLeftAlignment
    }, {
      [leftTopButton]: buttonTopLeftAlignment
    }, {
      [rightTopButtonRtl]: buttonTopRightAlignment && rtl
    }, {
      [rightTopButtonLtr]: buttonTopRightAlignment && !rtl
    }, {
      [centerButtonRtl]: buttonCenterAlignment && rtl
    }, {
      [centerButtonLtr]: buttonCenterAlignment && !rtl
    }, {
      [roundedButton]: isDetSite
    }),
    "aria-label": `${playButtonLabel} button`,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text"
  }, playButtonLabel), /*#__PURE__*/React.createElement("div", {
    className: `icon-play video-control-box rs_skip`
  }, isDetSite ? paused ? /*#__PURE__*/React.createElement(IconPlayDDA, null) : /*#__PURE__*/React.createElement(IconPauseDDA, null) : paused ? buttonFilled ? /*#__PURE__*/React.createElement(IconPlay2Item, null) : /*#__PURE__*/React.createElement(IconPlayItem, null) : /*#__PURE__*/React.createElement(IconPauseItem, null))));
};
const container = "c1ltgu9w";
const StyledVideo = "s131fr9h";
const StyledVideoFitCover = "s1sfttgl";
const ltrButton = "lxqb5mp";
const rtlButton = "rpnd126";
const topButton = "t1t42cp9";
const leftBottomButton = "l3rrbim";
const leftTopButton = "l1y68du6";
const rightTopButtonLtr = "r1exypts";
const rightTopButtonRtl = "r1k77vfo";
const bottomButton = "bz7l6hg";
const centerButtonLtr = "c1iytxdh";
const centerButtonRtl = "chae43a";
const roundedButton = "r19lcwc6";
export default Video;